import { useQuery, UseQueryOptions } from 'react-query';

import { QueryKeys } from '.';
import { useApi } from '../../context';
import { AxiosUtils } from '../../utils';
import { TermSheetFee } from '../../models';
import { CerebroApiEndpoints } from '../../utils/api';

export function useTermSheetFeesQuery(
	options?: Omit<UseQueryOptions<TermSheetFee[], unknown, TermSheetFee[], any>, 'queryKey' | 'queryFn'> | undefined
) {
	const api = useApi();

	return useQuery(
		QueryKeys.Lookups.TermSheetFees,
		() => AxiosUtils.getResponseData<TermSheetFee[]>(api.get(CerebroApiEndpoints.Lookups.TermSheetFees)),
		options
	);
}
